import {useCallback, useContext} from 'react';
import {useSelector} from 'react-redux';
import {useDispatch} from 'react-redux';

import {RESPONSE_STATUSES} from '@/src/app/constants/api';
import {
  selectClinicData,
  updateClinicSignatureData,
} from '@/src/app/store/clinic/clinicDataSlice';
import PopupContext from '@/src/popup/utils/PopupContext';
import ClinicCertificateBrandingLayout from '@/src/profile/accountSettings/components/ClinicCertificateBrandingLayout';
import deleteClinicLogo from '@/src/profile/accountSettings/utils/deleteClinicLogo';
import updateClinicSignature from '@/src/profile/accountSettings/utils/updateClinicSignature';
import TextLocal from '@/src/textLocal/containers/TextLocal';
import ImageCropper from '@/src/ui/ImageCropper/containers/ImageCropper';

const ClinicCertificateBranding = () => {
  const dispatch = useDispatch();
  const {clinicData} = useSelector(selectClinicData);
  const {closePopup, openPopup} = useContext(PopupContext);

  const handleSaveLogoClick = useCallback(
    async ({originalImage, standardPreview}): Promise<void> => {
      const {status, responseBody} = await updateClinicSignature(
        standardPreview,
        originalImage,
        clinicData.id
      );

      if (status === RESPONSE_STATUSES.SUCCESS) {
        dispatch(
          updateClinicSignatureData({
            signature: responseBody.signature,
            original_signature: responseBody.original_signature,
          })
        );
      }

      closePopup();
    },
    [clinicData.id]
  );

  const handleDeleteLogoClick = useCallback(async (): Promise<void> => {
    const {status} = await deleteClinicLogo(clinicData.id);

    if (status === RESPONSE_STATUSES.SUCCESS) {
      dispatch(
        updateClinicSignatureData({signature: null, original_signature: null})
      );
    }
  }, [clinicData.id]);

  const handleChangeLogoClick = useCallback(() => {
    // @ts-ignore
    openPopup({
      popup: (
        <ImageCropper
          aspect={2}
          onDeleteClick={handleDeleteLogoClick}
          onSavePreview={handleSaveLogoClick}
          originalImage={clinicData.original_signature}
          title={<TextLocal id={'profile.add-the-logo-to-your-clinic'} />}
          newUploadText={'profile.upload-new'}
        />
      ),
      options: {withCloseButton: true},
    });
  }, [openPopup, clinicData.original_signature]);

  return (
    <ClinicCertificateBrandingLayout
      signature={clinicData.signature}
      onChangeLogoClick={handleChangeLogoClick}
    />
  );
};

export default ClinicCertificateBranding;
